export interface FormFieldCustomEvent extends CustomEvent {
    detail: {
        value: any;
        event: Event;
    };
}

export type AddOrRemoveWishlistEvent = CustomEvent<{
    productId: number;
    variantId: number;
}>;

export type AttributesDateValue = {
    day: number | null;
    month: number | null;
    year: number | null;
};

export enum REWIEWS_BRANDING_LAUNCHER_VISIBILITY_TYPES {
    allDevices = "allDevices",
    desktopOnly = "desktopOnly",
    hide = "hide",
}

export type ReviewsIconState = "filled" | "half" | "empty";
